import React, { useState } from 'react';
import Layout from '../../Layout/Layout';
import { Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { addannouncement } from '../../actions/users';
import { toast } from 'react-toastify';
import { isEmpty } from '../../actions/commonFunction';

const AnnouncementAdd = () => {


    const navigate = useNavigate();

    const [validateError, setValidateError] = useState({});
    const [ formData, setFormData ] = useState({
        description: "",
        url: "",
    })
    const { description, url } = formData;


    const onChange = (e) => {
        setFormData({
            ...formData,
            ...{
                [e?.target?.id] : e?.target?.value
            }
        })
    }

    const handleValidation = async (e) => {

        try {
            let errors = {};
            if (description == '') {
                errors.description = 'Description field is required'
            }
            if (url == '') {
                errors.url = "Url field is required";
            }
            setValidateError(errors)
            return errors
        } catch (err) {
            console.error("handleValidation_err", err)
        }
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const validation = await handleValidation();
        let Objlen = await Object.keys(validation).length;
        

        if (Objlen == 0) {
            let reqData = { description, url }
            let { loading, result, error } = await addannouncement(reqData);
        
            if (isEmpty(error)) {
                toast.success('Announcement added successfully', 1000);
                navigate('/announcementlist')
            } else {
        
                setValidateError(error);
            }
        }

    }

    return (
        <Layout>
            <div className="announcementadd">
                <Link to="/announcementlist" className="btn sitebtn mb-4">Back</Link>
                <h1 className="pagehead">Create a new Announcement</h1>
                <div className="cardbox">
                    <Form>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control type="text" id="description" onChange={onChange} placeholder='Description' />
                                    {
                                        validateError.description && <span className="text-danger">{validateError.description}</span>
                                    }
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>URL</Form.Label>
                                    <Form.Control type="text" onChange={onChange} id="url" placeholder='URL'/>
                                    {
                                        validateError.url && <span className="text-danger">{validateError.url}</span>
                                    }
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                    <button type="button" className="btn sitebtn py-2 px-3" onClick={handleFormSubmit}>Add</button>
                </div>
            </div>
        </Layout>
    )
}

export default AnnouncementAdd;